import React from 'react'
import { ListNav, List } from '.'
import { ListFilter, FloatingFilter } from '../../../components'
import dummyData from '../data'

const MainContentMobile = ({ query, data, sortOptions, handleSort, countData }) => {
  const [selected, setSelected] = React.useState('Program')
  const [filtered, setFiltered] = React.useState(true)
  // const [data, setData] = React.useState(dummyData.program)

  // React.useEffect(() => {
  //   if(filtered){
  //     setData(dummyData[selected.toLowerCase()]?.slice(0, 3))
  //   }else{
  //     setData(dummyData[selected.toLowerCase()])
  //   }
  // }, [filtered, selected])

  return (
    <div>
      <ListNav rawData={dummyData} data={data} selected={selected} onChange={setSelected} mobile countData={countData}/>
      <div className="md:hidden">
        <ListFilter filtered={filtered} setFiltered={setFiltered}/>
      </div>
      <div className="hidden md:block container mx-auto">
        <ListFilter filtered={filtered} setFiltered={setFiltered}/>
      </div>
      <div className="container mx-auto">
        <List selected={selected} data={data}/>
      </div>
      <FloatingFilter onSubmit={() => setFiltered(true)}/>
    </div>
  )
}

export { MainContentMobile }
